import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import AniLink from "gatsby-plugin-transition-link/AniLink";

import ModalContact from "../Modal/ModalContact";
import Newsletter from "../Form/Newsletter";

const Footer = () => {
   const getYear = () => {
      return new Date().getFullYear();
   };

   // const [cityDropdownOpen, setCityDropdownOpen] = useState(false);

   // const citiesClickHandler = () => {
   //    setCityDropdownOpen(!cityDropdownOpen);
   // };

   const data = useStaticQuery(graphql`
      {
         logo: file(relativePath: { eq: "global/logo-light.svg" }) {
            publicURL
         }
         nestLogo: file(relativePath: { eq: "global/nest.svg" }) {
            publicURL
         }
         doucBank: file(relativePath: { eq: "global/DocuBank Portal.jpg" }) {
            childImageSharp {
               gatsbyImageData(layout: FIXED, width: 173, placeholder: BLURRED, quality: 100)
            }
         }
      }
   `);

   return (
      <div>
         <footer className="bg-gradient-to-b from-primary-900 to-primary-600 pt-14 md:pt-40 pb-6">
            <div className="container">
               <div className="grid md:grid-cols-12 md:gap-x-6 lg:gap-x-10 gap-y-12 mb-10 md:mb-7">
                  <div className="md:col-start-1 md:col-span-4">
                     <AniLink fade to="/">
                        <img src={data.logo.publicURL} alt="Conscious Legal Logo" width="278" className="mb-8 md:mb-0 mx-auto md:mx-0" />
                     </AniLink>
                  </div>
                  <div className="md:col-start-5 md:col-span-3">
                     <p className="text-white text font-heading text-2xl font-bold">Contact Us</p>
                     <ul>
                        <li className="mb-4">
                           <a className="text-white hover:text-white font-semibold" href="tel:-619-987-3532">
                              (619) 987-3532
                           </a>
                        </li>
                        <li className="mb-4">
                           <a
                              className="text-white hover:text-white"
                              href="https://goo.gl/maps/1C7QFcu9BSy2U4ML9"
                              target="_blank"
                              rel="noopener noreferrer"
                           >
                              3919 30th St, San Diego, CA 92104
                           </a>
                        </li>
                        <li>
                           <a
                              className="text-white hover:text-white"
                              href="https://goo.gl/maps/vwpwdW5xyhH2GpdH9"
                              target="_blank"
                              rel="noopener noreferrer"
                           >
                              170 Eucalyptus Avenue, #19, Vista, CA 92084
                           </a>
                        </li>
                     </ul>
                  </div>
                  <div className="md:col-start-8 md:col-span-3">
                     <p className="text-white text font-heading text-2xl font-bold">Practice Areas</p>
                     <ul>
                        <li className="mb-4">
                           <AniLink fade to="/estate-planning-small-business-owners/" className="text-white hover:text-white">
                              Estate Planning
                           </AniLink>
                        </li>
                        <li className="mb-4">
                           <AniLink fade to="/small-business-attorney/" className="text-white hover:text-white">
                              Business Advising
                           </AniLink>
                        </li>
                        <li>
                           <AniLink fade to="/long-term-care-planning-attorney/" className="text-white hover:text-white">
                              Long Term Care Planning
                           </AniLink>
                        </li>
                     </ul>
                  </div>
                  <div className="md:col-start-11 md:col-span-2">
                     <p className="text-white text font-heading text-2xl font-bold">About</p>
                     <ul>
                        <li className="mb-4">
                           <AniLink fade to="/about/" className="text-white hover:text-white">
                              About Us
                           </AniLink>
                        </li>
                        <li className="mb-4">
                           <AniLink fade to="/testimonials/" className="text-white hover:text-white">
                              Reviews
                           </AniLink>
                        </li>
                        <li className="mb-4">
                           <AniLink fade to="/alanna-pearl/" className="text-white hover:text-white">
                              Meet Alanna
                           </AniLink>
                        </li>
                        <li>
                           <AniLink fade to="/faq/" className="text-white hover:text-white">
                              FAQs
                           </AniLink>
                        </li>
                     </ul>
                  </div>
               </div>

               <div className="grid md:grid-cols-12 md:gap-x-10 gap-y-10 mb-24 md:mb-16">
                  <div className="md:col-start-1 md:col-span-4 md:-mt-24 order-2 md:order-1">
                     <a href="https://www.docubank.com/index.cfm?event=loginform" target="_blank" rel="noreferrer">
                        <GatsbyImage image={data.doucBank.childImageSharp.gatsbyImageData} alt="DocuBank logo" />
                     </a>
                  </div>
                  <div className="md:col-start-5 md:col-span-8 order-1 md:order-2">
                     <p className="font-heading text-2xl font-bold text-white mb-2">Newsletter Signup</p>
                     <p className="text-white text-sm max-w-2xl mb-4">
                        We promise not to spam you! Join our newsletter for valuable tips on how to protect your family from court and conflict, as
                        well as information about events and specials at Conscious Legal!
                     </p>
                     <Newsletter />
                  </div>
               </div>

               <div className="flex flex-wrap md:flex-nowrap flex-col md:flex-row justify-items-center md:justify-between items-center">
                  <div className="md:flex md:items-center order-2 md:order-1">
                     <ul className="flex items-center flex-col md:flex-row space-y-3 md:space-y-0 md:space-x-6">
                        <li className="text-sm text-white">© {getYear()} Conscious Legal, APC </li>
                        <li className="text-sm">
                           <a href="/terms-conditions/" className="text-white">
                              Terms & Conditions
                           </a>
                        </li>
                        <li className="text-sm">
                           <AniLink fade to="/privacy-policy/" className="text-white">
                              Privacy Policy
                           </AniLink>
                        </li>
                        <li className="text-sm text-white">
                           <div className="flex items-center justify-center mt-2 md:mt-0">
                              Powered by
                              <a
                                 className="group text-white flex items-center ml-1"
                                 href="https://www.wisedigitalpartners.com/affordable-web-design/"
                                 target="_blank"
                                 rel="noopener noreferrer"
                              >
                                 NEST<sup className="text-[6px] relative -top-[2px] left-[2px]">TM</sup>{" "}
                                 <img className="ml-2" src={data.nestLogo.publicURL} alt="nest Logo" />
                              </a>
                           </div>
                        </li>
                     </ul>
                  </div>

                  <div className="flex justify-center md:justify-items-start space-x-6 order-1 md:order-2 mb-12 md:mb-0">
                     <a href="https://www.facebook.com/consciouslegal/" target="_blank" rel="noopener noreferrer">
                        <i className="fab fa-facebook-f text-2xl text-white hover:text-primary-400 transition-all duration-300 ease-linear"></i>
                     </a>
                     <a href="https://www.instagram.com/consciouslegal_apc/" target="_blank" rel="noopener noreferrer">
                        <i className="fab fa-instagram text-2xl text-white hover:text-primary-400 transition-all duration-300 ease-linear"></i>
                     </a>
                     <a href="https://www.linkedin.com/in/alannajpearl/" target="_blank" rel="noopener noreferrer">
                        <i className="fab fa-linkedin text-2xl text-white hover:text-primary-400 transition-all duration-300 ease-linear"></i>
                     </a>
                  </div>
               </div>
            </div>
         </footer>

         <ModalContact />
      </div>
   );
};

export default Footer;
